import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useRole } from '../context/roleContext';

import { useFichario } from '../context/ficharioContext.js';
import { db } from '../firebase'
import { doc, getDoc } from 'firebase/firestore';
import { FirebaseError } from 'firebase/app';
import { useAlert } from '../context/alertContext';
import { axiosWithAuth } from '../services/api.js';




const Login = ({ chat, children }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [showResetConfirmation, setShowResetConfirmation] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [userType, setUserType] = useState('');
  const { role } = useRole();


  const { setFichario } = useFichario();
  const { setModoLogin } = useFichario();

  const { showAlert } = useAlert();




  const handleSubmit = async (e) => {
    e.preventDefault();

    //console.log("chat", chat, chat.chat === true);

    setError('');

    if (!email || !password) {
      showAlert('Por favor, preencha todos os campos.', 'tempo', 'erro');
      return;
    }


    try {

      await signInWithEmailAndPassword(auth, email, password);

      showAlert('Login realizado com sucesso.', 'tempo', 'ok');

      if (chat === true) {
        return
      }


      if (location.pathname === '/revisao') {
        // localStorage.setItem('currentStep', '1');
        setModoLogin(false);
      } else {
        navigate('/');
      }

    } catch (err) {

      // setError(err.message);
      if (err instanceof FirebaseError) {
        switch (err.code) {
          case 'auth/invalid-email':
            showAlert('O e-mail inserido é inválido.', 'tempo', 'erro');
            break;
          case 'auth/user-disabled':
            showAlert('Essa conta foi desativada.', 'tempo', 'erro');
            break;
          case 'auth/user-not-found':
            showAlert('Usuário não encontrado.', 'tempo', 'erro');
            break;
          case 'auth/wrong-password':
            showAlert('Senha incorreta.', 'tempo', 'erro');
            break;
          case 'auth/invalid-credential':
            showAlert('E-mail ou senha incorretos.', 'tempo', 'erro');
            break;
          case 'auth/too-many-requests':
            showAlert('Muitas tentativas de login. Aguarde um pouco antes de tentar novamente.', 'tempo', 'erro');
            break;
          default:
            showAlert('Erro ao fazer login. Tente novamente.', 'tempo', 'erro');
        }
      } else {
        showAlert(`Erro inesperado. Tente novamente mais tarde. ${err}`, 'tempo', 'erro');
      }

    }


  };



  const handlePasswordReset = async () => {
    setError('');

    if (!email) {
      showAlert('Por favor, insira seu e-mail.', 'tempo', 'erro');
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      showAlert('E-mail de redefinição de senha enviado!', 'tempo', 'ok');
      setShowResetConfirmation(true);
    } catch (err) {
      showAlert(err.message, 'tempo', 'erro');
    }
  };



  const handleNavigate = () => {
    navigate('/');
  };


  return (


    <div>

      <img className="user-logo login" src="/assets/userIcon.svg" alt=""></img>

      <div className="loginFormBox login-container">

        <div className='chat-toggle row flex-end'>
          <div class="login-toggle">
            <img src="/assets/close.svg" alt="Fechar" onClick={handleNavigate}></img>
          </div>
        </div>

        <div className='top-margin'>
          <h3>BEM-VINDO!</h3>
          <p className='small-top-margin'>Faça o login para continuar.</p>
        </div>

        <form onSubmit={handleSubmit}>

          <div className="input-container top-margin">
            <label>E-MAIL</label>
            <input
              type="email"
              placeholder="Email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>


          <div className="input-container top-margin">
            <label>SENHA</label>

            <div className="password-container row login">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                placeholder="Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <span
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (<img className="eyeSlash" src="/assets/eyeSlash.svg" alt="Ícone de olho fechado" />) : (<img className="eye" src="/assets/eye.svg" alt="Ícone de olho aberto" />)}
              </span>
            </div>
          </div>

          {!isLogin && (
            <div className="password-container row login">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder="Confirme sua senha"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <span
                className="eye-icon"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
              </span>
            </div>
          )}


          <div className="center">
            <button type="submit" className="loginButton top-margin">
              Entrar
            </button>
          </div>

        </form>

        <div className="center forgotPassword small-top-margin">
          <p onClick={handlePasswordReset} style={{ cursor: 'pointer' }}>
            Esqueci minha senha
          </p>
        </div>

        {children && (
          <div className="center">
            {children}
          </div>
        )}

      </div>

    </div>
  );
};

export default Login;